import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import ProductDetails from './pages/ProductDetails';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Contact from './pages/Contact';
import OrderSuccess from './pages/OrderSuccess';
import NotFound from './pages/NotFound';
import ToastContainer, { ToastMessage } from './components/ui/ToastContainer';

const App: React.FC = () => {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const removeToast = (id: string) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Helmet>
          <title>Calligraphy Art - Beautiful Hand-Crafted Calligraphy</title>
          <meta name="description" content="Transform your words into elegant works of art with our hand-crafted calligraphy services. Wedding invitations, personalized gifts, and custom designs." />
          <meta name="keywords" content="calligraphy, wedding invitations, personalized gifts, hand lettering, custom art" />
          <meta property="og:title" content="Calligraphy Art - Beautiful Hand-Crafted Calligraphy" />
          <meta property="og:description" content="Transform your words into elegant works of art with our hand-crafted calligraphy services." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://calligraphyart.com" />
          <meta property="og:image" content="https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=1200&h=630&fit=crop" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Calligraphy Art - Beautiful Hand-Crafted Calligraphy" />
          <meta name="twitter:description" content="Transform your words into elegant works of art with our hand-crafted calligraphy services." />
          <meta name="twitter:image" content="https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=1200&h=630&fit=crop" />
          <link rel="canonical" href="https://calligraphyart.com" />
        </Helmet>

        <Navbar />
        
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/product/:id" element={<ProductDetails />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/order-success" element={<OrderSuccess />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer />
        
        <ToastContainer toasts={toasts} onRemove={removeToast} />
      </div>
    </Router>
  );
};

export default App;
